package io.writeopia.editor.model

enum class EditState {
    TEXT,
    SELECTED_TEXT
}